var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-index page-index"},[_c('ContentTop'),_c('div',{staticClass:"live-title"},[_vm._v("直播再現")]),_c('LiveTimeTableArea',{attrs:{"coursetable_data":_vm.coursetable_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }